import { ArrowDownLeft, ArrowUpRight, Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatDate } from '@/lib/formatters';
import { Input } from '@/components/ui/input';
import {
  operationHistoryAmountClassNames,
  operationHistoryIconClassNames
} from './constants';
import { OperationHistoryItemType, OperationHistoryProps } from './types';

const getOperationIcon = (type: OperationHistoryItemType) => {
  if (type === 'credit') {
    return <ArrowDownLeft className="size-4" />;
  }

  return <ArrowUpRight className="size-4" />;
};

const OperationHistory = (props: OperationHistoryProps) => {
  if (props.variant === 'summary') {
    const {
      className,
      items
    } = props;

    return (
      <div className={cn('flex flex-col', className)}>
        {items.map((item) => (
          <div
            className="flex items-center gap-2 py-2 border-b border-border-strong last:border-b-0"
            key={item.id}
          >
            <div
              className={cn(
                'flex size-7 shrink-0 items-center justify-center',
                'rounded-full',
                operationHistoryIconClassNames[item.type]
              )}
            >
              {getOperationIcon(item.type)}
            </div>
            <div className="min-w-0 flex-1">
              <p className="whitespace-pre-wrap break-words font-sans text-sm font-semibold leading-5 text-foreground">
                {item.title}
              </p>
              <p className="truncate font-sans text-xs leading-4 text-muted-foreground">{item.shipmentNumber}</p>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1">
              <p
                className={cn(
                  'font-sans text-sm font-semibold leading-5',
                  operationHistoryAmountClassNames[item.type]
                )}
              >
                {item.amount}
              </p>
              <p className="font-sans text-xs leading-4 text-muted-foreground">
                {formatDate({ value: item.date, variant: 'date' })}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const {
    groups,
    onSearchChange,
    search
  } = props;

  return (
    <>
      <Input
        leftIcon={<Search className="size-5" />}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Поиск"
        type="search"
        value={search}
      />
      <div className="flex flex-col gap-6 opacity-80">
        {groups.length === 0 ? (
          <p className="py-4 text-center font-sans text-sm leading-5 text-muted-foreground">
            Поставка не найдена
          </p>
        ) : groups.map((group) => (
          <section
            className="flex flex-col gap-3"
            key={group.id}
          >
            <div className="flex items-center justify-between gap-4">
              <h2 className="font-sans text-base font-semibold leading-5 text-foreground">{group.number}</h2>
              <p className="shrink-0 font-sans text-xs leading-4 text-muted-foreground">{group.summary}</p>
            </div>
            <div className="flex flex-col rounded-2xl">
              {group.items.map((item) => (
                <div
                  className="flex items-start gap-2 py-2 border-b border-border-strong last:border-b-0"
                  key={item.id}
                >
                  <div
                    className={cn(
                      'flex size-7 shrink-0 items-center justify-center',
                      'rounded-full',
                      operationHistoryIconClassNames[item.type]
                    )}
                  >
                    {getOperationIcon(item.type)}
                  </div>
                  <div className="min-w-0 flex-1 pt-1">
                    <p className="whitespace-pre-wrap break-words font-sans text-sm font-semibold leading-5 text-foreground">
                      {item.title}
                    </p>
                  </div>
                  <div className="flex shrink-0 flex-col items-end gap-1">
                    <p
                      className={cn(
                        'font-sans text-sm font-semibold leading-5',
                        operationHistoryAmountClassNames[item.type]
                      )}
                    >
                      {item.amount}
                    </p>
                    <p className="font-sans text-xs leading-4 text-muted-foreground">
                      {formatDate({ value: item.date, variant: 'date' })}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

export default OperationHistory;